import api from '../../../utils/api'
import { useState, useEffect } from "react"

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

import ConfigBudgetForm from './Form/ConfigBudgetForm'

function EditConfigBudget({ id, btCancelAction, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [config, setConfig] = useState({})
    const [load, setLoad] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "configProposal_view")

    useEffect(() => {
        api.get(`/order/budget/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setConfig(response.data.budget)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }, [token, id])

    const submit = async (info) => {
        let msgType = 'success'
        const data = await api.patch(`order/budget/update/${config._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            handleOnSuccess()
        }
    }

    if (!load) return null

    /* PAGE */
    return (
        myPermissionView
            ? <ConfigBudgetForm title="Configuração da Proposta" dataConfig={config} handleOnSubmit={submit} btCancelAction={btCancelAction} />
            : <div>Sem permissão</div>
    )
}

export default EditConfigBudget
